import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveComponentModule } from '@ngrx/component';

import { UiIconModule } from '@cigna/ui/icon';
import { UiButtonModule } from '@cigna/ui/button';
import { UiProgressModule } from '@cigna/ui/progress';
import { AnalyticsUiModule } from '@cigna/analytics/ui';
import { UiPaginationModule } from '@cigna/ui/pagination';
import { UiDropdownModule } from '@cigna/ui/dropdown';

import { ChcpRoutes } from '@cigna/chcp/shared/util';
import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';

import { ChcpDashboardDataAccessModule } from '@cigna/chcp/dashboard/data-access';
import { ChcpDashboardUiModule } from '@cigna/chcp/dashboard/ui';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LatestUpdatesTileComponent } from './latest-updates-tile/latest-updates-tile.component';
import { ClaimsTileComponent } from './claims-tile/claims-tile.component';
import { PatientsTileComponent } from './patients-tile/patients-tile.component';
import { VerifyEmailDialogComponent } from './verify-email-dialog/verify-email-dialog.component';
import { NewFeaturesBannerComponent } from './new-features-banner/new-features-banner.component';
import { MessageCenterWidgetComponent } from './message-center-widget/message-center-widget.component';
import { ManageAccessTileComponent } from './manage-access-tile/manage-access-tile.component';
import { ManageAccessViewUserDialogComponent } from './manage-access-view-user-dialog/manage-access-view-user-dialog.component';

const routes: ChcpRoutes = [
  {
    path: '',
    pathMatch: 'full',
    component: DashboardComponent,
    data: {
      title: 'Dashboard',
      bluebar: true,
      analytics: {
        name: 'Dashboard',
        section: 'Dashboard',
        prop13: 'pv-DB003-Dashboard',
      },
    },
  },
];

@NgModule({
  imports: [
    CommonModule,
    ChcpDashboardUiModule,
    ChcpDashboardDataAccessModule,
    ChcpSharedEnvironmentUtilModule,
    ReactiveComponentModule,
    AnalyticsUiModule,
    UiIconModule,
    UiButtonModule,
    UiProgressModule,
    UiPaginationModule,
    UiDropdownModule,
    RouterModule.forChild(routes),
    MatDialogModule,
    TranslateModule,
    ChcpSharedUiModule,
  ],
  declarations: [
    DashboardComponent,
    LatestUpdatesTileComponent,
    ClaimsTileComponent,
    PatientsTileComponent,
    VerifyEmailDialogComponent,
    NewFeaturesBannerComponent,
    MessageCenterWidgetComponent,
    ManageAccessTileComponent,
    ManageAccessViewUserDialogComponent,
  ],
  exports: [DashboardComponent],
})
export class ChcpDashboardShellFeatureModule {}
